import { render, staticRenderFns } from "./ConcludeWizardStep.vue?vue&type=template&id=2bc465c0&"
import script from "./ConcludeWizardStep.vue?vue&type=script&lang=js&"
export * from "./ConcludeWizardStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports